import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    white-space: pre-wrap;\n    padding: 0.3em;\n    margin: 0;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    overflow: hidden;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React, { useRef } from 'react';
import styled from 'styled-components';
import { stripIndent } from '../../helpers/stripIndent';
import { useElementSize } from '../../hooks/useElementSize';
import { useStep } from '../../hooks/useStep';
import { trail, fromTo, val } from 'light-trails';
export const Output = props => {
  const ref = useRef(null);
  const size = useElementSize(ref);
  useStep(props.in, ({
    duration
  }) => trail(ref.current, [fromTo({
    height: val(0, size.height, 'px'),
    opacity: val(0, 1)
  }, duration.normal)]), {
    title: 'Output',
    deps: [size !== null]
  });
  return React.createElement(Container, {
    ref: ref
  }, React.createElement(Code, null, stripIndent(props.text).trim()));
};
const Container = styled.div(_templateObject());
const Code = styled.pre(_templateObject2());